import { Theme } from '@mui/material';
import { SKELETON_RADIUS } from './Skeleton.types';

export function getSkeletonBackgroundColor(theme: Theme): string {
    return theme.palette.ds.bg.neutral.tertiary;
}

export function getSkeletonBorderRadius(theme: Theme): string {
    return theme.borders.ds.borderRadius[SKELETON_RADIUS];
}
